import React, {Suspense} from 'react';

// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {Provider as ReduxProvider} from 'react-redux';
import {PersistGate} from 'redux-persist/lib/integration/react';

import reportWebVitals from './reportWebVitals';

// redux
import {persistor, store} from './redux/store';
// @mui
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers';

import App from './App';

import {SettingsProvider} from "./components/settings";
import ScrollToTop from "./components/scrollToTop";
import {AuthProvider} from "./auth/FirebaseContext";
import LoadingScreen from "./components/loading-screen";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Suspense fallback={<LoadingScreen/>}>
        <AuthProvider>
            <HelmetProvider>
                <ReduxProvider store={store}>
                    <PersistGate loading={<LoadingScreen/>} persistor={persistor}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <SettingsProvider>
                                <BrowserRouter>
                                    <ScrollToTop/>
                                    <App/>
                                </BrowserRouter>
                            </SettingsProvider>
                        </LocalizationProvider>
                    </PersistGate>
                </ReduxProvider>
            </HelmetProvider>
        </AuthProvider>
    </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
